export enum EServiceTypeRate {
  RATE_BASED = "rate_based",
  FLAT_FEE = "flat_fee",
}

export enum EServiceTypeRateUnit {
  HOUR = "hour",
  PROJECT = "project",
  PIECE = "piece",
}

export const getServiceTypeRateUnitLabel = (
  rateUnit: EServiceTypeRateUnit,
  quantity: number = 1
) => {
  switch (rateUnit) {
    case EServiceTypeRateUnit.HOUR:
      return quantity > 1 ? "Hours" : "Hour";
    case EServiceTypeRateUnit.PROJECT:
      return quantity > 1 ? "Projects" : "Project";
    case EServiceTypeRateUnit.PIECE:
      return quantity > 1 ? "Pieces" : "Piece";
    default:
      return undefined;
  }
};

export const getServiceTypeRateLabel = (rate: EServiceTypeRate) => {
  switch (rate) {
    case EServiceTypeRate.RATE_BASED:
      return "Rate Based";
    case EServiceTypeRate.FLAT_FEE:
      return "Flat Fee";
    default:
      return undefined;
  }
};
